import { defineStore } from 'pinia'
import { reactive, computed } from 'vue'
import { getInitialState, resetState } from './state'
import { createActions } from './actions'
import { createGetters } from './getters'

export const useUsersStore = defineStore('users', () => {
  const state = reactive(getInitialState())
  const actions = createActions(state)
  const getters = createGetters(state)

  const $reset = () => {
    resetState(state)
  }

  return {
    // State
    users: computed(() => state.users),
    selectedUser: computed(() => state.selectedUser),
    isLoading: computed(() => state.isLoading),
    error: computed(() => state.error),
    filters: computed(() => state.filters),

    // Getters
    filteredUsers: computed(() => getters.filteredUsers()),
    activeUsers: computed(() => getters.activeUsers()),
    admins: computed(() => getters.admins()),
    operators: computed(() => getters.operators()),
    clients: computed(() => getters.clients()),
    totalUsers: computed(() => getters.totalUsers()),
    totalActiveUsers: computed(() => getters.totalActiveUsers()),
    getUserById: getters.getUserById,
    usersByRole: getters.usersByRole,

    // Actions
    ...actions,

    // Reset
    $reset,
  }
})
